/**
 * Generated Vessel Requirements from Domain Pack CSVs
 * Generated on: 2025-10-06T20:01:56.853Z
 * Source: UK-MARITIME-LIBRARY/03-CSV-DATABASES/SEAGOING/domains
 * 
 * DO NOT EDIT THIS FILE DIRECTLY - It is auto-generated from domain pack CSV data
 * To update requirements, modify the CSV files and run: npm run update-requirements-from-domains
 */

// Requirements from domain packs
export const domainPackRequirements = {
  "basicEquipment": [],
  "equipment": [
    {
      "id": "FFE_v2_ffe.extinguisher.outboard.le220kw",
      "name": "Fire Extinguisher - Outboard ≤220kW",
      "category": "FFE",
      "description": "Single outboard ≤220kW",
      "reference": "WBC3 Table 16.1.1.1",
      "gate": "isSeagoing & hasOutboard & !enginePowerGT:220",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.extinguisher.outboard.gt220kw",
      "name": "Fire Extinguisher - Outboard >220kW",
      "category": "FFE",
      "description": "3P\"",
      "reference": "WBC3 Table 16.1.1.1",
      "gate": "isSeagoing & hasOutboard & enginePowerGT:220",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.extinguisher.inboard.lt120kw",
      "name": "Fire Extinguisher - Inboard Diesel <120kW",
      "category": "FFE",
      "description": "Located adjacent to entrance",
      "reference": "WBC3 Table 16.1.1.1",
      "gate": "isSeagoing & hasInboardDiesel & enginePowerLT:120",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.extinguisher.enginebox.above",
      "name": "Fire Protection - Diesel Engine Box Above Deck",
      "category": "FFE",
      "description": "Fixed system is alternative",
      "reference": "WBC3 Table 16.1.1.1",
      "gate": "isSeagoing & hasInboardDiesel & engineAboveDeck",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.fixed.system.primary",
      "name": "Fixed Fire Extinguishing System",
      "category": "FFE",
      "description": "Required below deck; optional above deck",
      "reference": "WBC3 16.4; Table 16.1.1.1",
      "gate": "isSeagoing & hasInboardDiesel & (engineBelowDeck | (engineAboveDeck & choosesFixed))",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.extinguisher.accommodation.basic",
      "name": "Fire Extinguisher - Basic Accommodation",
      "category": "FFE",
      "description": "Each accommodation space",
      "reference": "WBC3 16.2.1.2",
      "gate": "isSeagoing & hasAccommodation & !hasSleeping & !hasCooking & !hasHeating",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.extinguisher.accommodation.sleeping.only",
      "name": "Fire Extinguisher - Sleeping Only",
      "category": "FFE",
      "description": "Sleeping without cooking/heating",
      "reference": "WBC3 16.2.1.2",
      "gate": "isSeagoing & hasSleeping & !hasCooking & !hasHeating",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.extinguisher.cooking.noflame",
      "name": "Fire Protection - No Open Flame",
      "category": "FFE",
      "description": "Electric/induction",
      "reference": "WBC3 Table 16.2.3.1",
      "gate": "isSeagoing & (hasCooking | hasHeating) & !hasOpenFlame",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.extinguisher.cooking.flame",
      "name": "Fire Protection - Open Flame",
      "category": "FFE",
      "description": "OR fixed per 16.4",
      "reference": "WBC3 Table 16.2.3.1",
      "gate": "isSeagoing & (hasCooking | hasHeating) & hasOpenFlame",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.extinguisher.openboat.le8m",
      "name": "Open Boat ≤8m Protection",
      "category": "FFE",
      "description": "Open boats <8m",
      "reference": "WBC3 Table 16.1.1.1 Note d",
      "gate": "isSeagoing & isOpenBoat & lengthLT:8 & !hasSubstantialEnclosure & !hasCooking",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.fire.pump.required",
      "name": "Fire Pump",
      "category": "FFE",
      "description": "Exempt only if open boat AND <8m AND no enclosure",
      "reference": "WBC3 16.4.2.1",
      "gate": "isSeagoing & (!isOpenBoat | !lengthLT:8 | hasSubstantialEnclosure)",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.fire.hose.fitted",
      "name": "Fire Hose",
      "category": "FFE",
      "description": "With 10mm + spray nozzles",
      "reference": "WBC3 16.4.2.4",
      "gate": "isSeagoing & hasFirePump",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.fire.buckets.fitted",
      "name": "Fire Buckets",
      "category": "FFE",
      "description": "CA discretion; not required where multiple ext/fixed systems",
      "reference": "WBC3 16.6.1; Note 65",
      "gate": "isSeagoing & (isPracticable | deemedNecessary | companyRequiresBuckets) & !(hasMultipleExtinguishers | hasFixedFireSystem)",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.fire.blanket",
      "name": "Fire Blanket",
      "category": "FFE",
      "description": "When identified by CA or open flame cooking",
      "reference": "WBC3 16.5",
      "gate": "isSeagoing & ((hasCooking | hasHeating) & hasOpenFlame | hasFireRiskArea)",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.detector.machinery",
      "name": "Fire Detection - Machinery Space",
      "category": "FFE",
      "description": " or flame\"",
      "reference": "WBC3 15.6.2.4",
      "gate": "isSeagoing & hasMachinerySpace",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.detector.accommodation",
      "name": "Fire Detector - Accommodation",
      "category": "FFE",
      "description": "Appropriate type for hazard",
      "reference": "WBC3 15.6.2.1",
      "gate": "isSeagoing & hasAccommodation",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.detector.openflame.spaces",
      "name": "Fire Detector - Open Flame Spaces",
      "category": "FFE",
      "description": " gas or liquid fuel appliances\"",
      "reference": "WBC3 15.6.2.1",
      "gate": "isSeagoing & (hasOpenFlame | hasGasAppliance | hasLiquidFuelAppliance)",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.detector.electrical.concentration",
      "name": "Fire Detector - Electrical Areas",
      "category": "FFE",
      "description": "Appropriate type",
      "reference": "WBC3 15.6.2.1",
      "gate": "isSeagoing & hasConcentratedElectrical",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.detector.co.accommodation",
      "name": "CO Detector - Accommodation",
      "category": "FFE",
      "description": " gas or liquid fuel appliances are installed in",
      "reference": "WBC3 15.6.3.1",
      "gate": "isSeagoing & hasAccommodation & (hasOpenFlame | hasGasAppliance | hasLiquidFuelAppliance)",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.detector.co.exhaust",
      "name": "CO Detector - Exhaust Risk Areas",
      "category": "FFE",
      "description": "Exhaust leak protection",
      "reference": "WBC3 15.6.3.3",
      "gate": "isSeagoing & hasExhaustLeakRisk",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.detector.gas.hydrocarbon",
      "name": "Hydrocarbon Gas Detector",
      "category": "FFE",
      "description": "With alarm required",
      "reference": "WBC3 15.6.4.1",
      "gate": "isSeagoing & (hasGasAppliance | hasGasLeakRisk)",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.detector.lithium.system",
      "name": "Fire Detection System - Li-ion Battery",
      "category": "FFE",
      "description": " heat and flame detectors\"",
      "reference": "WBC3 Annex 1 3.2.1",
      "gate": "isSeagoing & hasLithiumBattery",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.plan.fire.control",
      "name": "Fire Control and Safety Plan",
      "category": "FFE",
      "description": "Shows all fire equipment locations",
      "reference": "WBC3 15.8.1",
      "gate": "isSeagoing",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.escape.route.marking",
      "name": "Escape Route Marking",
      "category": "FFE",
      "description": "Both sides marked",
      "reference": "WBC3 15.7.4",
      "gate": "isSeagoing & hasEscapeRoute",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.fire.pump.dangerous.goods",
      "name": "Fire Pump - Dangerous Goods",
      "category": "FFE",
      "description": "Required for all DG vessels",
      "reference": "WBC3 29.8.1",
      "gate": "isSeagoing & hasDangerousGoods",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.insulation.a60.dangerous.goods",
      "name": "A-60 Insulation - Dangerous Goods",
      "category": "FFE",
      "description": "DG within 3m of fuel/machinery/accommodation",
      "reference": "WBC3 29.7.1",
      "gate": "isSeagoing & hasDangerousGoods & dgNearAccommodation",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.extinguisher.pilot.boat.no.petrol",
      "name": "Pilot Boat - No Petrol Engine",
      "category": "FFE",
      "description": "Safety requirement",
      "reference": "WBC3 27.2.3 Table 8.6",
      "gate": "isSeagoing & isPilotBoat & hasPetrolEngine",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.flares.pilot.boat.white",
      "name": "Pilot Boat - White Flares",
      "category": "FFE",
      "description": "For emergency use in rescues at night",
      "reference": "WBC3 27.2.3 Table 14.1",
      "gate": "isSeagoing & isPilotBoat",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_ffe.flares.pilot.boat.red",
      "name": "Pilot Boat - Red Flares",
      "category": "FFE",
      "description": "Emergency signaling",
      "reference": "WBC3 27.2.3 Table 14.1",
      "gate": "isSeagoing & isPilotBoat",
      "mandatory": true,
      "source": "FFE_v2"
    },
    {
      "id": "LSA_v2_lsa.lifejackets.adult",
      "name": "Lifejackets (Adult)",
      "category": "LSA",
      "description": "All adults",
      "reference": "WBC3 14.4.4",
      "gate": "TRUE",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.lifejackets.child",
      "name": "Lifejackets (Child)",
      "category": "LSA",
      "description": "Children under 32kg",
      "reference": "WBC3 14.4.4",
      "gate": "pobChildrenGTE:1",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.lifejackets.spare",
      "name": "Spare Lifejackets (Inflatable)",
      "category": "LSA",
      "description": "Inflatable spares",
      "reference": "WBC3 14.4.4",
      "gate": "hasInflatableLifejackets",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.lifebuoys.standard",
      "name": "Lifebuoys",
      "category": "LSA",
      "description": "Standard requirement",
      "reference": "WBC3 14.3;Table 14.1.2",
      "gate": "TRUE",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.liferafts.cat2to6",
      "name": "Liferafts (Cat 2-6)",
      "category": "LSA",
      "description": " 3",
      "reference": "WBC3 14.2.4.2",
      "gate": "isSeagoing & isCatAtLeast:2",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.rescue.boat",
      "name": "Rescue Boat",
      "category": "LSA",
      "description": "Standard rescue boat",
      "reference": "WBC3 14.7.1",
      "gate": "hasRescueBoat",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.fast.rescue.boat",
      "name": "Fast Rescue Boat",
      "category": "LSA",
      "description": "Fast rescue boat",
      "reference": "WBC3 14.7.1",
      "gate": "hasFastRescueBoat",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.immersion.suits",
      "name": "Immersion Suits",
      "category": "LSA",
      "description": "When carried",
      "reference": "WBC3 14.5.7",
      "gate": "hasImmersionSuits",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.tpa.cats0to5",
      "name": "TPA (Categories 0-5)",
      "category": "LSA",
      "description": "Categories 0-5",
      "reference": "WBC3 14.5.1",
      "gate": "isSeagoing & isCatAtMost:5",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.pyrotechnics.flares",
      "name": "Distress Pyrotechnics",
      "category": "LSA",
      "description": "Per category table",
      "reference": "WBC3 Table 14.1.2",
      "gate": "TRUE",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.sart",
      "name": "SART or AIS-SART",
      "category": "LSA",
      "description": " 1 or 2 shall carry … SART\"",
      "reference": "WBC3 14.12.3",
      "gate": "isSeagoing & isCatAtMost:2",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.general.alarm.pob",
      "name": "General Alarm (POB)",
      "category": "LSA",
      "description": "POB trigger",
      "reference": "WBC3 14.6.1",
      "gate": "isSeagoing & isCatAtMost:2 & pobGE:16",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.general.alarm.power",
      "name": "General Alarm (Power)",
      "category": "LSA",
      "description": "Power trigger",
      "reference": "WBC3 14.6.1",
      "gate": "isSeagoing & installedPowerGT:750",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.pa.system",
      "name": "Public Address System",
      "category": "LSA",
      "description": "With general alarm",
      "reference": "WBC3 14.6.2",
      "gate": "hasGeneralAlarm",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.line.throwing",
      "name": "Line Throwing Apparatus",
      "category": "LSA",
      "description": "Guidance only",
      "reference": "MIN 698",
      "gate": "hasLineThrowing",
      "mandatory": false,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.recovery.equipment",
      "name": "MOB Recovery Equipment",
      "category": "LSA",
      "description": "Includes scrambling nets ladders slings or other systems",
      "reference": "WBC3 14.7/MGN 544",
      "gate": "isSeagoing",
      "mandatory": false,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.pilot.lifelines",
      "name": "Buoyant Lifelines (Pilot Boat)",
      "category": "LSA",
      "description": "Pilot boat specific",
      "reference": "WBC3 Table 27.2.3 14.7",
      "gate": "isPilotBoat",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.evacuation.system",
      "name": "Marine Evacuation System",
      "category": "LSA",
      "description": "Large passenger only",
      "reference": "SOLAS",
      "gate": "passengerVessel & pobGTE:250",
      "mandatory": false,
      "source": "LSA_v2"
    },
    {
      "id": "NAVIGATION_v1_nav.compass.magnetic",
      "name": "Magnetic Compass",
      "category": "NAVIGATION",
      "description": "With consistent deviation",
      "reference": "WBC3 19.2.1",
      "gate": "isSeagoing",
      "mandatory": true,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_nav.compass.bearing",
      "name": "Bearing Equipment",
      "category": "NAVIGATION",
      "description": "Non-steel vessels can use hand bearing compass",
      "reference": "WBC3 19.2.3.2/footnote 73",
      "gate": "isSeagoing",
      "mandatory": true,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_nav.publications.police.alternative",
      "name": "Publications Alternative (Police)",
      "category": "NAVIGATION",
      "description": "ALTERNATIVE to paper",
      "reference": "WBC3 Annex 3 13.2.1",
      "gate": "isPoliceVessel & hasElectronicPubs & !hasPaperPubs",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_nav.ecdis",
      "name": "ECDIS",
      "category": "NAVIGATION",
      "description": "Alternative to paper charts",
      "reference": "WBC3 19.3.4/MGN 319",
      "gate": "isSeagoing & hasECDIS & !hasPaperCharts",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_nav.lamp.signalling",
      "name": "Signalling Lamp",
      "category": "NAVIGATION",
      "description": "All vessels",
      "reference": "WBC3 19.4.1",
      "gate": "isSeagoing",
      "mandatory": true,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_nav.echo.sounder",
      "name": "Echo Sounder",
      "category": "NAVIGATION",
      "description": " or other effective means\"",
      "reference": "WBC3 19.5.1",
      "gate": "isSeagoing",
      "mandatory": true,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_nav.lights",
      "name": "Navigation Lights",
      "category": "NAVIGATION",
      "description": "All COLREGS requirements",
      "reference": "WBC3 18.1/SI 1996 No.75",
      "gate": "isSeagoing",
      "mandatory": true,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_nav.shapes.day",
      "name": "Day Shapes",
      "category": "NAVIGATION",
      "description": "Includes pilot/anchor/NUC etc",
      "reference": "WBC3 18.1/Table 18.4",
      "gate": "isSeagoing",
      "mandatory": true,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_nav.sound.signal",
      "name": "Sound Signals",
      "category": "NAVIGATION",
      "description": "Whistle/bell per size",
      "reference": "WBC3 18.3/Table 18.4",
      "gate": "isSeagoing",
      "mandatory": true,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "MACHINERY_v1_machinery.propulsion.main",
      "name": "Main Propulsion System",
      "category": "MACHINERY",
      "description": "Marine use engine/motor",
      "reference": "WBC3 8.1.1",
      "gate": "isSeagoing",
      "mandatory": true,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_machinery.steering.system",
      "name": "Steering System",
      "category": "MACHINERY",
      "description": "Primary steering system",
      "reference": "WBC3 10.2.1",
      "gate": "isSeagoing",
      "mandatory": true,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_machinery.fuel.tanks",
      "name": "Fuel Tanks",
      "category": "MACHINERY",
      "description": "Permanent or portable per vessel size",
      "reference": "WBC3 8.12",
      "gate": "isSeagoing",
      "mandatory": true,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_machinery.killcord",
      "name": "Kill Cord System",
      "category": "MACHINERY",
      "description": "Open steering positions",
      "reference": "WBC3 8.9.1",
      "gate": "isSeagoing & hasOpenSteeringPosition",
      "mandatory": true,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_machinery.bilge.pump.hand",
      "name": "Hand Bilge Pump",
      "category": "MACHINERY",
      "description": "Each separate space",
      "reference": "WBC3 11.2.1.1",
      "gate": "isSeagoing",
      "mandatory": true,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_machinery.bilge.pump.powered",
      "name": "Powered Bilge Pump",
      "category": "MACHINERY",
      "description": "Engine or independent power",
      "reference": "WBC3 11.2.1.1",
      "gate": "isSeagoing",
      "mandatory": true,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_machinery.bilge.alarm",
      "name": "Bilge Alarm",
      "category": "MACHINERY",
      "description": "Watertight compartments with machinery",
      "reference": "WBC3 11.3.1",
      "gate": "isSeagoing & hasMachinerySpace",
      "mandatory": true,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_machinery.rudder.system",
      "name": "Rudder System",
      "category": "MACHINERY",
      "description": " the design...of a rudder system\"",
      "reference": "WBC3 10.3.1",
      "gate": "isSeagoing & hasRudder",
      "mandatory": true,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_machinery.engine.starting",
      "name": "Engine Starting System",
      "category": "MACHINERY",
      "description": "Mechanical/air/electric",
      "reference": "WBC3 8.8.1",
      "gate": "isSeagoing",
      "mandatory": true,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_machinery.battery.backup",
      "name": "Backup Starting Battery",
      "category": "MACHINERY",
      "description": "For battery-only starting",
      "reference": "WBC3 8.8.2",
      "gate": "isSeagoing & hasElectricStart",
      "mandatory": true,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_machinery.air.receivers",
      "name": "Air Start Receivers",
      "category": "MACHINERY",
      "description": "6 consecutive starts each",
      "reference": "WBC3 8.8.3",
      "gate": "isSeagoing & hasAirStart",
      "mandatory": true,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_machinery.ventilation.machinery",
      "name": "Machinery Space Ventilation",
      "category": "MACHINERY",
      "description": "Remote stop capability",
      "reference": "WBC3 15.1.1.4",
      "gate": "isSeagoing & hasMachinerySpace",
      "mandatory": true,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_machinery.fuel.isolation",
      "name": "Fuel Isolation Valve",
      "category": "MACHINERY",
      "description": "Outside machinery space",
      "reference": "WBC3 8.10.3",
      "gate": "isSeagoing & hasMachinerySpace",
      "mandatory": true,
      "source": "MACHINERY_v1"
    },
    {
      "id": "ELECTRICAL_v1_electrical.battery.system",
      "name": "Battery System",
      "category": "ELECTRICAL",
      "description": "Primary and emergency power",
      "reference": "WBC3 9.3.1.1",
      "gate": "isSeagoing & hasElectricalSystem",
      "mandatory": true,
      "source": "ELECTRICAL_v1"
    },
    {
      "id": "ELECTRICAL_v1_electrical.lighting.system",
      "name": "Lighting System",
      "category": "ELECTRICAL",
      "description": "All accommodation and working spaces",
      "reference": "WBC3 9.2.1",
      "gate": "isSeagoing & hasElectricalSystem",
      "mandatory": true,
      "source": "ELECTRICAL_v1"
    },
    {
      "id": "ELECTRICAL_v1_electrical.switchgear",
      "name": "Switchgear",
      "category": "ELECTRICAL",
      "description": " which includes the main electrical switching and protective devices\"",
      "reference": "WBC3 9.4.1",
      "gate": "isSeagoing & hasElectricalSystem",
      "mandatory": true,
      "source": "ELECTRICAL_v1"
    },
    {
      "id": "ELECTRICAL_v1_electrical.charger.system",
      "name": "Battery Charger",
      "category": "ELECTRICAL",
      "description": "If fitted",
      "reference": "WBC3 9.3.1.3",
      "gate": "isSeagoing & hasElectricalSystem",
      "mandatory": false,
      "source": "ELECTRICAL_v1"
    },
    {
      "id": "MEDICAL_v1_medical.dg.kit",
      "name": "Dangerous Goods Medical Kit",
      "category": "MEDICAL",
      "description": "Per MFAG guidance",
      "reference": "WBC3 29.9.1/MSN 1905 Annex 4",
      "gate": "isSeagoing & hasDangerousGoods",
      "mandatory": true,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_medical.dg.antidotes",
      "name": "Specific Antidotes",
      "category": "MEDICAL",
      "description": "For DG exceeding IMDG limits",
      "reference": "WBC3 29.9.2",
      "gate": "isSeagoing & hasDangerousGoods & dgExceedsLimits",
      "mandatory": true,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_medical.firstaid.police.pwc",
      "name": "First Aid Kit (Police PWC)",
      "category": "MEDICAL",
      "description": "For Police Personal Watercraft",
      "reference": "WBC3 Annex 3 22.6.3.2",
      "gate": "isPoliceVessel & isPWC",
      "mandatory": true,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_medical.stretcher.pilot",
      "name": "Compact Stretcher",
      "category": "MEDICAL",
      "description": "Pilot boats only",
      "reference": "WBC3 Table 27.2.3",
      "gate": "isPilotBoat",
      "mandatory": true,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_medical.kit.rouv",
      "name": "Portable Medical Kit (ROUV)",
      "category": "MEDICAL",
      "description": "For ROUV boarding operations",
      "reference": "WBC3 Annex 2 6.4.2",
      "gate": "isUnmanned & hasRemoteBoarding",
      "mandatory": true,
      "source": "MEDICAL_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.vhf.fixed.dsc",
      "name": "Fixed VHF DSC Radio",
      "category": "GMDSS",
      "description": "All sea areas",
      "reference": "WBC3 17.2.1/Table 17.2.1",
      "gate": "isSeagoing & (seaAreaA1 | seaAreaA2 | seaAreaA3 | seaAreaA4)",
      "mandatory": true,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.vhf.portable.dsc",
      "name": "Portable VHF DSC Radio",
      "category": "GMDSS",
      "description": "Minimum requirement",
      "reference": "WBC3 17.4.1",
      "gate": "isSeagoing",
      "mandatory": true,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.vhf.portable.multiple",
      "name": "Additional Portable VHF (Multiple Rafts)",
      "category": "GMDSS",
      "description": "Multiple rafts only",
      "reference": "WBC3 17.4.8",
      "gate": "isSeagoing & hasMultipleLiferafts",
      "mandatory": true,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.vhf.ch70.watch",
      "name": "VHF Ch70 DSC Watch",
      "category": "GMDSS",
      "description": "Continuous watch required",
      "reference": "WBC3 17.2.1/Table 17.2.1",
      "gate": "isSeagoing & (seaAreaA1 | seaAreaA2 | seaAreaA3 | seaAreaA4)",
      "mandatory": true,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.mfhf.dsc.nbdp",
      "name": "MF/HF Radio DSC/NBDP",
      "category": "GMDSS",
      "description": "A3/A4 areas",
      "reference": "WBC3 17.2.1/Table 17.2.1",
      "gate": "isSeagoing & (seaAreaA3 | seaAreaA4)",
      "mandatory": true,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.satellite.service",
      "name": "Mobile Satellite Service",
      "category": "GMDSS",
      "description": "Alternative to MF/HF",
      "reference": "WBC3 17.2.1/Table 17.2.1",
      "gate": "isSeagoing & (seaAreaA2 | seaAreaA3) & !hasMF",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.vhf.portable.police",
      "name": "Additional Portable VHF DSC (Police)",
      "category": "GMDSS",
      "description": "Fully charged before departure",
      "reference": "WBC3 Annex 3 13.4.2",
      "gate": "isPoliceVessel",
      "mandatory": true,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.vhf.portable.police.timeline",
      "name": "Portable VHF Timeline (Police)",
      "category": "GMDSS",
      "description": "Transition period",
      "reference": "WBC3 Annex 3 12.3",
      "gate": "isPoliceVessel",
      "mandatory": true,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.vhf.fixed.police.exempt",
      "name": "Fixed VHF Exemption (Police Inland)",
      "category": "GMDSS",
      "description": "Inland waters only",
      "reference": "WBC3 Annex 3 13.5",
      "gate": "isPoliceVessel & operatesInlandOnly & !hasFixedVHF",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.vhf.portable.protection",
      "name": "VHF Waterproof Protection",
      "category": "GMDSS",
      "description": "Required protection",
      "reference": "WBC3 Annex 3 Note 4",
      "gate": "isPoliceVessel & hasPortableVHF",
      "mandatory": true,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.roc.operator",
      "name": "ROC GMDSS Operator",
      "category": "GMDSS",
      "description": "Valid GMDSS certificate",
      "reference": "WBC3 Annex 2 7.1.3",
      "gate": "isROUV & hasROC",
      "mandatory": true,
      "source": "GMDSS_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_environmental.garbage.receptacles",
      "name": "POLLUTION",
      "category": "ENVIRONMENTAL",
      "description": "Adequate storage for garbage types",
      "reference": "WBC3 30.3.1",
      "gate": "isSeagoing",
      "mandatory": true,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_environmental.garbage.placards",
      "name": "POLLUTION",
      "category": "ENVIRONMENTAL",
      "description": "Display disposal restrictions",
      "reference": "WBC3 30.3/MGN 632",
      "gate": "lengthGT:12",
      "mandatory": true,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_environmental.sewage.holding.tank",
      "name": "POLLUTION",
      "category": "ENVIRONMENTAL",
      "description": "Where direct discharge prohibited",
      "reference": "WBC3 30.2.2",
      "gate": "hasProhibitedDischargeArea & !hasIMOSewageSystem",
      "mandatory": true,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_environmental.sewage.treatment.system",
      "name": "POLLUTION",
      "category": "ENVIRONMENTAL",
      "description": "MARPOL Annex IV requirement",
      "reference": "WBC3 30.2.1",
      "gate": "(grossTonnageGT:400 | (grossTonnageLT:400 & POB:GT:15)) & hasInternationalVoyage",
      "mandatory": true,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_environmental.oil.sludge.tank",
      "name": "POLLUTION",
      "category": "ENVIRONMENTAL",
      "description": "Sludge and oil mixture storage",
      "reference": "MARPOL Annex I",
      "gate": "hasOilySludge",
      "mandatory": true,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_environmental.oil.standard.discharge",
      "name": "POLLUTION",
      "category": "ENVIRONMENTAL",
      "description": "For shore reception facilities",
      "reference": "MARPOL Annex I",
      "gate": "grossTonnageGT:400",
      "mandatory": true,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_environmental.oil.bilge.alarm",
      "name": "POLLUTION",
      "category": "ENVIRONMENTAL",
      "description": "15ppm bilge alarm required",
      "reference": "MARPOL Annex I",
      "gate": "grossTonnageGT:400",
      "mandatory": true,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_environmental.oil.bilge.separator",
      "name": "POLLUTION",
      "category": "ENVIRONMENTAL",
      "description": "15ppm separator equipment",
      "reference": "MARPOL Annex I",
      "gate": "grossTonnageGT:400",
      "mandatory": true,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_environmental.dg.fire.extinguisher",
      "name": "SAFETY",
      "category": "ENVIRONMENTAL",
      "description": "Suitable for DG carried",
      "reference": "IMDG Code",
      "gate": "hasDangerousGoods",
      "mandatory": true,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_environmental.dg.first.aid",
      "name": "MEDICAL",
      "category": "ENVIRONMENTAL",
      "description": "Enhanced for DG hazards",
      "reference": "IMDG Code",
      "gate": "hasDangerousGoods",
      "mandatory": true,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_environmental.dg.ppe",
      "name": "SAFETY",
      "category": "ENVIRONMENTAL",
      "description": "PPE for dangerous goods handling",
      "reference": "IMDG Code",
      "gate": "hasDangerousGoods",
      "mandatory": true,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_environmental.fuel.cleanup",
      "name": "POLLUTION",
      "category": "ENVIRONMENTAL",
      "description": "Spill cleanup materials",
      "reference": "MARPOL Annex I",
      "gate": "hasFuelSystem",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_environmental.fuel.drip.trays",
      "name": "POLLUTION",
      "category": "ENVIRONMENTAL",
      "description": "Prevent deck contamination",
      "reference": "MARPOL Annex I",
      "gate": "hasFuelSystem",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_environmental.fuel.drain.plugs",
      "name": "POLLUTION",
      "category": "ENVIRONMENTAL",
      "description": "Seal scuppers during transfer",
      "reference": "MARPOL Annex I",
      "gate": "hasFuelSystem",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.crane",
      "name": "DECK",
      "category": "OPERATIONS",
      "description": "Vessel fitted with crane for lifting operations",
      "reference": "WBC3 25.2",
      "gate": "hasCrane",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.lifting.device",
      "name": "DECK",
      "category": "OPERATIONS",
      "description": "Other lifting devices including davits or hoists",
      "reference": "WBC3 25.2",
      "gate": "hasLiftingDevice & !hasCrane",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.diver.lift",
      "name": "DECK",
      "category": "OPERATIONS",
      "description": "Lift system for diver recovery operations",
      "reference": "WBC3 25.3",
      "gate": "hasDiverLift",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.lifting.equipment",
      "name": "DECK",
      "category": "OPERATIONS",
      "description": "General category for lifting equipment not specified above",
      "reference": "WBC3 25.2",
      "gate": "hasLiftingOps",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.lifting.accessories",
      "name": "DECK",
      "category": "OPERATIONS",
      "description": "Includes slings shackles strops hooks eyebolts etc",
      "reference": "WBC3 25.2/LOLER",
      "gate": "hasLiftingOps",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.towline.main",
      "name": "DECK",
      "category": "OPERATIONS",
      "description": "Primary towline for towing operations",
      "reference": "WBC3 26",
      "gate": "hasTowingOps",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.towline.emergency",
      "name": "DECK",
      "category": "OPERATIONS",
      "description": "Pre-rigged emergency towline for backup",
      "reference": "WBC3 26.4.4",
      "gate": "hasTowingOps",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.towing.winch",
      "name": "DECK",
      "category": "OPERATIONS",
      "description": "Winch for controlled towing operations",
      "reference": "WBC3 26",
      "gate": "hasTowingOps",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.towing.hook",
      "name": "DECK",
      "category": "OPERATIONS",
      "description": "Quick release towing hook",
      "reference": "WBC3 26",
      "gate": "hasTowingOps",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.gob.rope",
      "name": "DECK",
      "category": "OPERATIONS",
      "description": "Anti-girting rope to prevent capsizing",
      "reference": "WBC3 26",
      "gate": "hasTowingOps",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.towing.bollard",
      "name": "DECK",
      "category": "OPERATIONS",
      "description": "Heavy duty bollard for towing operations",
      "reference": "WBC3 26",
      "gate": "hasTowingOps",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.dive.basket",
      "name": "DECK",
      "category": "OPERATIONS",
      "description": "Platform or basket for diver deployment/recovery",
      "reference": "WBC3 25.3",
      "gate": "hasDiveBasket",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.dive.ladder",
      "name": "DECK",
      "category": "OPERATIONS",
      "description": "Ladder for diver water access",
      "reference": "WBC3 25.3",
      "gate": "hasDiveLadder",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.pilot.stretcher",
      "name": "MEDICAL",
      "category": "OPERATIONS",
      "description": "Compact stretcher for pilot boat operations",
      "reference": "WBC3 Table 27.2.3",
      "gate": "isPilotBoat",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.pilot.searchlight",
      "name": "NAVIGATION",
      "category": "OPERATIONS",
      "description": "Searchlight for pilot transfer operations",
      "reference": "WBC3 Table 27.2.3",
      "gate": "isPilotBoat",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.pilot.recovery",
      "name": "DECK",
      "category": "OPERATIONS",
      "description": "Transom steps/ladder or scrambling net for MOB recovery",
      "reference": "WBC3 Table 27.2.3 14.7",
      "gate": "isPilotBoat",
      "mandatory": true,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.fuel.pump",
      "name": "MACHINERY",
      "category": "OPERATIONS",
      "description": "Pump for fuel transfer operations",
      "reference": "WBC3 29.10.1.6",
      "gate": "hasBunkeringOps",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.fuel.hose",
      "name": "DECK",
      "category": "OPERATIONS",
      "description": "Hoses for fuel transfer with dry break coupling",
      "reference": "WBC3 29.10.1.8",
      "gate": "hasBunkeringOps",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.fuel.cleanup",
      "name": "POLLUTION",
      "category": "OPERATIONS",
      "description": "Spill cleanup kit for fuel operations",
      "reference": "WBC3 29.10.1.5",
      "gate": "hasBunkeringOps",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.fuel.shutoff",
      "name": "SAFETY",
      "category": "OPERATIONS",
      "description": "Emergency shut-down button for fuel pump",
      "reference": "WBC3 29.10.1.6",
      "gate": "hasBunkeringOps",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.police.searchlight",
      "name": "NAVIGATION",
      "category": "OPERATIONS",
      "description": "Fixed or portable searchlight for MOB operations",
      "reference": "WBC3 Annex 3 13.5.1",
      "gate": "isPoliceVessel",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.gangway",
      "name": "DECK",
      "category": "OPERATIONS",
      "description": "Gangway for personnel transfer operations",
      "reference": "WBC3 25.5",
      "gate": "hasPersonnelTransfer",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_operations.equipment.fenders",
      "name": "DECK",
      "category": "OPERATIONS",
      "description": "Fendering for alongside operations",
      "reference": "WBC3 25.5.2",
      "gate": "hasPersonnelTransfer | hasTowingOps",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    }
  ],
  "basicCertificates": [],
  "certificates": [],
  "basicDocumentation": [],
  "documentation": [
    {
      "id": "FFE_v2_doc_55",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_56",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_57",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_58",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_59",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_60",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_61",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_62",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_63",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_64",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_65",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_66",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_67",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_68",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_69",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_70",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_71",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_72",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_73",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_74",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_75",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_76",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "FFE_v2_doc_77",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "FFE_v2"
    },
    {
      "id": "LSA_v2_doc_125",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_doc_126",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_doc_127",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_doc_128",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_doc_129",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_doc_130",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_doc_131",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "LSA_v2"
    },
    {
      "id": "NAVIGATION_v1_doc_171",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_172",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_173",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_174",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_175",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_176",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_177",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_178",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_179",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_180",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_181",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_182",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_183",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_184",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_185",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_186",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_187",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_188",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_189",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_doc_190",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "MACHINERY_v1_doc_219",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_doc_220",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_doc_221",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_doc_222",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_doc_223",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_doc_224",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_doc_225",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_doc_226",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_doc_227",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_doc_228",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_doc_229",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_doc_230",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_doc_231",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_doc_232",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MACHINERY_v1"
    },
    {
      "id": "MACHINERY_v1_doc_233",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MACHINERY_v1"
    },
    {
      "id": "ELECTRICAL_v1_doc_241",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ELECTRICAL_v1"
    },
    {
      "id": "ELECTRICAL_v1_doc_242",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ELECTRICAL_v1"
    },
    {
      "id": "ELECTRICAL_v1_doc_243",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ELECTRICAL_v1"
    },
    {
      "id": "ELECTRICAL_v1_doc_244",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ELECTRICAL_v1"
    },
    {
      "id": "ELECTRICAL_v1_doc_245",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ELECTRICAL_v1"
    },
    {
      "id": "ELECTRICAL_v1_doc_246",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ELECTRICAL_v1"
    },
    {
      "id": "MEDICAL_v1_doc_263",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_doc_264",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_doc_265",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_doc_266",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_doc_267",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_doc_268",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_doc_269",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_doc_270",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_doc_271",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_doc_272",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_doc_273",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_doc_274",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_doc_275",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_doc_276",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_doc_277",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_doc_278",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_doc_279",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "MEDICAL_v1"
    },
    {
      "id": "GMDSS_v1_doc_313",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_doc_314",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_doc_315",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_doc_316",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_doc_317",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_doc_318",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_doc_319",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_doc_320",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_doc_321",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_doc_322",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_doc_323",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_doc_324",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_doc_325",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_doc_326",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_doc_327",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_354",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_355",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_356",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_357",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_358",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_359",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_360",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_361",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_362",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_363",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_364",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_365",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_366",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_367",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_368",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_369",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_370",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_371",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_372",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_373",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "ENVIRONMENTAL_v1_doc_374",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "ENVIRONMENTAL_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_412",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_413",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_414",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_415",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_416",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_417",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_418",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_419",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_420",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_421",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_422",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_423",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_424",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_425",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_426",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_427",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_428",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_429",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_430",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_431",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_432",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_433",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_434",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "OPERATIONS_v1_doc_435",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "OPERATIONS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_448",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_449",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_450",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_451",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_452",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_453",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_454",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_455",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_456",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_457",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_458",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_459",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_460",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_461",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_462",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_463",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_464",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_465",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_466",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "SURVEYS_v1_doc_467",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "SURVEYS_v1"
    },
    {
      "id": "CREW_v1_doc_468",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_469",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_470",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_471",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_472",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_473",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_474",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_475",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_476",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_477",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_478",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_479",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_480",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_481",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_482",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_483",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_484",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_485",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_486",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_487",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_488",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_489",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_490",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_491",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_492",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_493",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_494",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_495",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_496",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_497",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_498",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_499",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_500",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    },
    {
      "id": "CREW_v1_doc_501",
      "category": "Documentation",
      "reference": "WBC3",
      "mandatory": false,
      "source": "CREW_v1"
    }
  ],
  "training": [],
  "procedures": [],
  "assessments": [],
  "riskAssessments": [],
  "restrictions": [],
  "areaCategoryEquipment": [
    {
      "id": "LSA_v2_lsa.liferafts.cat0",
      "name": "Liferafts (Cat 0)",
      "category": "LSA",
      "description": "Redundancy required",
      "reference": "WBC3 14.2.4.1",
      "gate": "isSeagoing & isCat:0",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.liferafts.cat1.pob16plus",
      "name": "Liferafts (Cat 1 ≥16 POB)",
      "category": "LSA",
      "description": "Redundancy required",
      "reference": "WBC3 14.2.4.1",
      "gate": "isSeagoing & isCat:1 & pobGE:16",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.liferafts.cat1.pobunder16",
      "name": "Liferafts (Cat 1 <16 POB)",
      "category": "LSA",
      "description": "Standard capacity",
      "reference": "WBC3 14.2.4.2",
      "gate": "isSeagoing & isCat:1 & pobLT:16",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.tpa.cat6.cold",
      "name": "TPA (Cat 6 Cold Water)",
      "category": "LSA",
      "description": "Cat 6 cold water",
      "reference": "WBC3 14.5.2.1",
      "gate": "isSeagoing & isCat:6 & waterTempLE:10",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.tpa.cat6.openraft",
      "name": "TPA (Cat 6 Open Raft)",
      "category": "LSA",
      "description": "Cat 6 open raft",
      "reference": "WBC3 14.5.2.2",
      "gate": "isSeagoing & isCat:6 & hasOpenLiferaft",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.epirb.cat0",
      "name": "EPIRB Cat 0",
      "category": "LSA",
      "description": "Category 0",
      "reference": "WBC3 17.5;Table 14.1.2",
      "gate": "isSeagoing & isCat:0",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "LSA_v2_lsa.epirb.cat1to2",
      "name": "EPIRB Cat 1-2",
      "category": "LSA",
      "description": "Categories 1-2",
      "reference": "WBC3 17.5;Table 14.1.2",
      "gate": "isSeagoing & (isCat:1 | isCat:2)",
      "mandatory": true,
      "source": "LSA_v2"
    },
    {
      "id": "NAVIGATION_v1_nav.compass.light",
      "name": "Compass Light",
      "category": "NAVIGATION",
      "description": " 1",
      "reference": "WBC3 19.2.7; Annex 3 13.1.1",
      "gate": "(isSeagoing & (isCat:0 | isCat:1 | isCat:2 | isCat:3 | isCat:5)) | (isPoliceVessel & operatesAtNight)",
      "mandatory": true,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_nav.charts",
      "name": "Nautical Charts",
      "category": "NAVIGATION",
      "description": "Not Cat 6",
      "reference": "WBC3 19.3.1",
      "gate": "isSeagoing & !isCat:6",
      "mandatory": true,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_nav.publications.nautical",
      "name": "Nautical Publications",
      "category": "NAVIGATION",
      "description": "Not Cat 6",
      "reference": "WBC3 19.3.1",
      "gate": "isSeagoing & !isCat:6",
      "mandatory": true,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_nav.radar.reflector",
      "name": "Radar Reflector",
      "category": "NAVIGATION",
      "description": "MIN 698 standard",
      "reference": "WBC3 19.6.1",
      "gate": "isSeagoing & !isCat:6",
      "mandatory": true,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_nav.radar.reflector.cat6",
      "name": "Radar Reflector (Cat 6)",
      "category": "NAVIGATION",
      "description": "Must avoid fog",
      "reference": "WBC3 19.6.2",
      "gate": "isSeagoing & isCat:6 & isPracticable",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_nav.radar.reflector.police.cat5",
      "name": "Radar Reflector Exemption (Police Cat 5)",
      "category": "NAVIGATION",
      "description": "Police boats only",
      "reference": "WBC3 Annex 3 13.3.1",
      "gate": "isPoliceVessel & isCat:5 & !hasRadarReflector & favourableWeatherOnly",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_nav.gps",
      "name": "GPS/GNSS",
      "category": "NAVIGATION",
      "description": "Or terrestrial system",
      "reference": "WBC3 19.7.1.1",
      "gate": "isSeagoing & (isCat:0 | isCat:1 | isCat:2)",
      "mandatory": true,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_nav.log.distance",
      "name": "Distance Log",
      "category": "NAVIGATION",
      "description": "Unless GPS provides",
      "reference": "WBC3 19.7.1.2",
      "gate": "isSeagoing & (isCat:0 | isCat:1 | isCat:2) & !gpsProvideDistance",
      "mandatory": false,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_nav.radar.3cm",
      "name": "3cm Radar",
      "category": "NAVIGATION",
      "description": "MIN 698 standard",
      "reference": "WBC3 19.7.1.3",
      "gate": "isSeagoing & (isCat:0 | isCat:1 | isCat:2)",
      "mandatory": true,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "NAVIGATION_v1_nav.ais.transceiver",
      "name": "AIS Transceiver",
      "category": "NAVIGATION",
      "description": "MIN 698 guidelines",
      "reference": "WBC3 19.7.1.4",
      "gate": "isSeagoing & (isCat:0 | isCat:1 | isCat:2)",
      "mandatory": true,
      "source": "NAVIGATION_v1"
    },
    {
      "id": "MEDICAL_v1_medical.stores.cat.a",
      "name": "Medical Stores Category A",
      "category": "MEDICAL",
      "description": "Unlimited voyage vessels",
      "reference": "WBC3 23.1.1.1/MSN 1905",
      "gate": "isSeagoing & isCat:0",
      "mandatory": true,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_medical.stores.cat.b",
      "name": "Medical Stores Category B",
      "category": "MEDICAL",
      "description": "Vessels <150nm from port",
      "reference": "WBC3 23.1.1.2/MSN 1905",
      "gate": "isSeagoing & isCat:1",
      "mandatory": true,
      "source": "MEDICAL_v1"
    },
    {
      "id": "MEDICAL_v1_medical.stores.cat.c",
      "name": "Medical Stores Category C",
      "category": "MEDICAL",
      "description": "Near shore/harbour vessels",
      "reference": "WBC3 23.1.1.3/MSN 1905",
      "gate": "isSeagoing & (isCat:2 | isCat:3 | isCat:4 | isCat:5 | isCat:6)",
      "mandatory": true,
      "source": "MEDICAL_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.mf.dsc",
      "name": "MF Radio with DSC",
      "category": "GMDSS",
      "description": "Alternative to satellite",
      "reference": "WBC3 17.2.1/Table 17.2.1",
      "gate": "isSeagoing & (seaAreaA2 | (seaAreaA1 & isCat:0))",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.epirb.mandatory",
      "name": "EPIRB 406MHz (Required)",
      "category": "GMDSS",
      "description": "Float-free required",
      "reference": "WBC3 17.5.1/Table 17.2.1",
      "gate": "isSeagoing & ((isCat:0 | isCat:1 | isCat:2) | ((isCat:3 | isCat:4) & !seaAreaA1) | isCat:5)",
      "mandatory": true,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.epirb.recommended",
      "name": "EPIRB 406MHz (Recommended)",
      "category": "GMDSS",
      "description": "A1 only recommendation",
      "reference": "WBC3 Table 17.2.1 Notes",
      "gate": "isSeagoing & (isCat:3 | isCat:4) & seaAreaA1 & ineffectiveNonGMDSS",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.epirb.second",
      "name": "Second EPIRB",
      "category": "GMDSS",
      "description": "Stowed accessible",
      "reference": "WBC3 17.5.2",
      "gate": "isSeagoing & isCat:0 & isManned",
      "mandatory": true,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.plb.mandatory",
      "name": "PLB 406MHz (Required)",
      "category": "GMDSS",
      "description": "Recommended all crew but min 1 required",
      "reference": "WBC3 17.6.1/17.6.2/Table 17.2.1",
      "gate": "isSeagoing & (isCat:0 | isCat:1 | isCat:2 | isCat:3 | isCat:4)",
      "mandatory": true,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.plb.recommended.cat5",
      "name": "PLB 406MHz (Recommended)",
      "category": "GMDSS",
      "description": "Recommended for all crew on deck",
      "reference": "WBC3 Table 17.2.1",
      "gate": "isSeagoing & isCat:5 & seaAreaA1",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.plb.mandatory.cat5",
      "name": "PLB 406MHz (Cat 5 A2+)",
      "category": "GMDSS",
      "description": "Recommended all crew but min 1 required",
      "reference": "WBC3 Table 17.2.1/17.6.2",
      "gate": "isSeagoing & isCat:5 & !seaAreaA1",
      "mandatory": true,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.plb.conditional.cat6",
      "name": "PLB 406MHz (Conditional)",
      "category": "GMDSS",
      "description": "Cat 6 conditional",
      "reference": "WBC3 Table 17.2.1 Note C2",
      "gate": "isSeagoing & isCat:6 & ineffectiveNonGMDSS",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.sart",
      "name": "SART",
      "category": "GMDSS",
      "description": "Radar or AIS type",
      "reference": "WBC3 14.12.3",
      "gate": "isSeagoing & (isCat:0 | isCat:1 | isCat:2)",
      "mandatory": true,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.sart.second",
      "name": "Second SART",
      "category": "GMDSS",
      "description": "Exemptions may apply",
      "reference": "WBC3 14.12.4",
      "gate": "isSeagoing & (isCat:0 | isCat:1 | isCat:2)",
      "mandatory": true,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.navtex.mandatory",
      "name": "NAVTEX Receiver (Required)",
      "category": "GMDSS",
      "description": "Required for Cat 0-3 outside A1",
      "reference": "WBC3 17.2.1/Table 17.2.1",
      "gate": "isSeagoing & ((isCat:0 | isCat:1 | isCat:2 | isCat:3) & (seaAreaA2 | seaAreaA3 | seaAreaA4))",
      "mandatory": true,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.navtex.conditional.a1",
      "name": "NAVTEX Receiver (Conditional A1)",
      "category": "GMDSS",
      "description": "Required if voyage >12hrs",
      "reference": "WBC3 Table 17.2.1 Note B",
      "gate": "isSeagoing & (isCat:0 | isCat:1 | isCat:2 | isCat:3) & seaAreaA1 & voyageGT:12hours",
      "mandatory": false,
      "source": "GMDSS_v1"
    },
    {
      "id": "GMDSS_v1_gmdss.navtex.conditional.cat5",
      "name": "NAVTEX Receiver (Conditional Cat5)",
      "category": "GMDSS",
      "description": "If no other weather source",
      "reference": "WBC3 Table 17.2.1 Note C1",
      "gate": "isSeagoing & isCat:5 & !canGetWeatherInfo",
      "mandatory": false,
      "source": "GMDSS_v1"
    }
  ],
  "crewCertificationByArea": []
};

/**
 * Get vessel requirements based on configuration
 * @param {Object} vesselConfig - Vessel configuration object
 * @returns {Object} Requirements object with all applicable requirements
 */
export function getRequirementsFromDomains(vesselConfig) {
  const applicableRequirements = {};
  
  // Clone the base structure
  Object.keys(domainPackRequirements).forEach(category => {
    applicableRequirements[category] = domainPackRequirements[category].filter(req => {
      return checkRequirementApplies(req, vesselConfig);
    });
  });
  
  return applicableRequirements;
}

/**
 * Check if a requirement applies to the vessel based on gate logic
 */
function checkRequirementApplies(req, vesselConfig) {
  // No gate means always applies
  if (!req.gate || req.gate === '' || req.gate === 'always' || req.gate === 'ALL') {
    return true;
  }
  
  // Parse gate logic (simplified version - expand as needed)
  const gate = req.gate;
  
  // Category gates
  if (gate.includes('isCat:')) {
    const catMatch = gate.match(/isCat:(\d+)/);
    if (catMatch) {
      const requiredCat = parseInt(catMatch[1]);
      const vesselCat = vesselConfig.category;
      
      // Check if gate includes range (e.g., "isCat:0-2")
      if (gate.includes('-')) {
        const rangeMatch = gate.match(/isCat:(\d+)-(\d+)/);
        if (rangeMatch) {
          const min = parseInt(rangeMatch[1]);
          const max = parseInt(rangeMatch[2]);
          return vesselCat >= min && vesselCat <= max;
        }
      }
      
      // Check if gate includes "or less" (e.g., "isCat:<=2")
      if (gate.includes('<=')) {
        const maxMatch = gate.match(/isCat:<=(\d+)/);
        if (maxMatch) {
          const max = parseInt(maxMatch[1]);
          return vesselCat <= max;
        }
      }
      
      // Exact match
      return vesselCat === requiredCat;
    }
  }
  
  // Seagoing check
  if (gate.includes('isSeagoing')) {
    const isSeagoing = vesselConfig.operatingStatus !== 'inland';
    if (gate.includes('!isSeagoing')) {
      return !isSeagoing;
    }
    return isSeagoing;
  }
  
  // Passenger operations
  if (gate.includes('hasPassengers')) {
    return vesselConfig.carriesPassengers || vesselConfig.vesselType === 'pax';
  }
  
  // Engine type gates
  if (gate.includes('engineType:')) {
    const typeMatch = gate.match(/engineType:(\w+)/);
    if (typeMatch) {
      return vesselConfig.engineType === typeMatch[1];
    }
  }
  
  // Default to true for unknown gates (safer to include than exclude)

  return true;
}

// Export counts for debugging
export function getRequirementCounts() {
  const counts = {};
  Object.keys(domainPackRequirements).forEach(category => {
    counts[category] = domainPackRequirements[category].length;
  });
  counts.total = Object.values(counts).reduce((sum, count) => sum + count, 0);
  return counts;
}
